// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-container {
  position: absolute;
  top: 50px;
  right: 65px;
  cursor: pointer;
}
.switch-container .switch {
  position: relative;
  width: 22px;
  height: 24px;
  object-fit: contain;
  background-image: url('bell.2ee54be7a0b4c450.svg');
}
.switch-container .switch .count {
  position: absolute;
  bottom: 9px;
  left: 13px;
  padding: 1px;
  background-color: #b39841;
  min-width: 24px;
  min-height: 24px;
  border-radius: 100%;
  border: solid 1px #b39841;
  text-align: center;
}
.switch-container .switch .count span {
  font-family: Montserrat-Regular, sans-serif;
  font-size: 12px;
  color: #ffffff;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .switch-container .switch .count span {
    vertical-align: text-top;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .switch-container {
    right: 75px !important;
  }
}
.tray-container {
  width: 550px;
  height: 1000px;
  position: absolute;
  top: 0;
  right: -550px;
  background-color: #444444;
  transition: right 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  overflow: hidden;
  z-index: 40;
}
.tray-container.expanded {
  right: 0;
}
.tray-container .notification-box {
  padding: 16px 14px 23px 26px;
  min-height: 66px;
  border-bottom: 1px solid #5e5e5e;
  color: #ffffff;
  opacity: 1;
  transition: opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.tray-container .notification-box.read {
  background-color: #333333;
  color: #cccccc;
}
.tray-container .notification-box.fade {
  opacity: 0;
}
.tray-container .notification-box .title-container {
  width: 100%;
  margin-bottom: 5px;
}
.tray-container .notification-box .title-container .title {
  font-family: Montserrat-Regular, sans-serif;
  font-size: 18px;
  text-align: left;
}
.tray-container .notification-box .title-container .close-circle {
  width: 24px;
  height: 24px;
  object-fit: contain;
  float: right;
  background-image: url('close-circle.ce4097ed45dc398c.svg');
  cursor: pointer;
}
.tray-container .notification-box .title-container .close-circle:hover,
.tray-container .notification-box .title-container .close-circle:focus {
  background-image: url('close-circle-hover.8122d2f1408175c5.svg');
}
.tray-container .notification-box .title-container .close-cross {
  width: 24px;
  height: 24px;
  object-fit: contain;
  float: right;
  background-image: url('cross.94f7db39b7176d24.svg');
  cursor: pointer;
}
.tray-container .notification-box .title-container .close-cross:hover,
.tray-container .notification-box .title-container .close-cross:focus {
  background-image: url('cross-hover.51d99dd21ec0e20c.svg');
}
.tray-container .notification-box .description {
  width: 419px;
  margin-bottom: 5px;
  font-family: Montserrat-Regular, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  text-align: left;
}
.tray-container .notification-box .subtitle {
  margin-top: 12px;
  font-family: WarnockPro-Regular, serif;
  font-size: 15px;
  text-align: left;
  color: #cccccc;
  display: inline-block;
  margin-right: 16px;
}
.tray-container .notification-box .dismiss-all {
  font-family: WarnockPro-Regular, serif;
  font-size: 15px;
  color: #ffffff;
}
.tray-container .notification-box .dismiss-all:hover,
.tray-container .notification-box .dismiss-all:focus {
  color: #b39841;
  cursor: pointer;
}
.tray-container .notification-box .action {
  width: 70px;
  height: 35px;
  background-color: #7F6C2E;
  cursor: pointer;
  float: right;
  text-align: center;
}
.tray-container .notification-box .action .text {
  font-family: Montserrat-Semibold, sans-serif;
  font-size: 14px;
  line-height: 35px;
  color: #ffffff;
  text-decoration: none;
}
.tray-container .notification-box .action .text:hover {
  color: #ffffff !important;
}
.tray-container .notification-box .action:hover,
.tray-container .notification-box .action:focus {
  background-color: #685925;
}
.tray-container .notification-box.head {
  padding-top: 26px;
}
.overlay {
  background-color: transparent;
  transition: background-color 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.overlay.active {
  width: 1920px;
  height: 100%;
  position: absolute;
  top: 0;
  opacity: 0.75;
  background-color: #000000;
  z-index: 30;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/notifications/notifications-tray/notifications-tray.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AADJ;AAHA;EAOQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kDAAA;AADR;AAVA;EAcY,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AADZ;AAtBA;EA0BgB,2CAAA;EACA,eAAA;EACA,cAAA;AADhB;AAGgB;EAAA;IACI,wBAAA;EAAlB;AACF;AAMI;EACI;IACI,sBAAA;EAJV;AACF;AAOI;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,yBAAA;EACA,0DAAA;EACA,gBAAA;EACA,WAAA;AALR;AAOQ;EACI,QAAA;AALZ;AAPI;EAgBQ,4BAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;EACA,4DAAA;AANZ;AAQY;EACI,yBAAA;EACA,cAAA;AANhB;AASY;EACI,UAAA;AAPhB;AAtBI;EAiCY,WAAA;EACA,kBAAA;AARhB;AA1BI;EAqCgB,2CAAA;EACA,eAAA;EACA,gBAAA;AARpB;AA/BI;EA2CgB,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,0DAAA;EACA,eAAA;AATpB;AAWoB;;EAEI,gEAAA;AATxB;AA3CI;EAyDgB,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mDAAA;EACA,eAAA;AAXpB;AAaoB;;EAEI,yDAAA;AAXxB;AAvDI;EAwEY,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAdhB;AA/DI;EAiFY,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAfhB;AAxEI;EA2FY,sCAAA;EACA,eAAA;EACA,cAAA;AAhBhB;AAkBgB;;EAEI,cAAA;EACA,eAAA;AAhBpB;AAlFI;EAuGY,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAlBhB;AA1FI;EA+GgB,4CAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAlBpB;AAoBoB;EACI,yBAAA;AAlBxB;AAsBgB;;EAEI,yBAAA;AApBpB;AAwBY;EACI,iBAAA;AAtBhB;AA2BI;EACI,6BAAA;EACA,qEAAA;AAzBR;AA2BQ;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AAzBZ","sourcesContent":["@import (reference) '../../../styles/variables.less';\n\n.switch-container {\n    position: absolute;\n    top: 50px;\n    right: 65px;\n    cursor: pointer;\n\n    .switch {\n        position: relative;\n        width: 22px;\n        height: 24px;\n        object-fit: contain;\n        background-image: url(../../../styles/img/bell.svg);\n\n        .count {\n            position: absolute;\n            bottom: 9px;\n            left: 13px;\n            padding: 1px;\n            background-color: @primary-90;\n            min-width: 24px;\n            min-height: 24px;\n            border-radius: 100%;\n            border: solid 1px @primary-90;\n            text-align: center;\n\n            span {\n                font-family: Montserrat-Regular, sans-serif;\n                font-size: 12px;\n                color: @white;\n\n                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n                    vertical-align: text-top;\n                    }\n                }\n            }\n        }\n    }\n\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        .switch-container {\n            right: 75px !important;\n        }\n    }\n\n    .tray-container {\n        width: 550px;\n        height: 1000px;\n        position: absolute;\n        top: 0;\n        right: -550px;\n        background-color: @secondary-90;\n        transition: right .2s cubic-bezier(.215,.61,.355,1);\n        overflow: hidden;\n        z-index: 40;\n\n        &.expanded {\n            right: 0;\n        }\n\n        .notification-box {\n            padding: 16px 14px 23px 26px;\n            min-height: 66px;\n            border-bottom: 1px solid @secondary-80;\n            color: @white;\n            opacity: 1;\n            transition: opacity .2s cubic-bezier(.215,.61,.355,1);\n\n            &.read {\n                background-color: @secondary-base;\n                color: @secondary-30;\n            }\n\n            &.fade {\n                opacity: 0;\n            }\n\n            .title-container {\n                width: 100%;\n                margin-bottom: 5px;\n\n                .title {\n                    font-family: Montserrat-Regular, sans-serif;\n                    font-size: 18px;\n                    text-align: left;\n                }\n\n                .close-circle {\n                    width: 24px;\n                    height: 24px;\n                    object-fit: contain;\n                    float: right;\n                    background-image: url(../../../styles/img/close-circle.svg);\n                    cursor: pointer;\n\n                    &:hover,\n                    &:focus  {\n                        background-image: url(../../../styles/img/close-circle-hover.svg);\n                    }\n                }\n\n                .close-cross {\n                    width: 24px;\n                    height: 24px;\n                    object-fit: contain;\n                    float: right;\n                    background-image: url(../../../styles/img/cross.svg);\n                    cursor: pointer;\n\n                    &:hover,\n                    &:focus  {\n                        background-image: url(../../../styles/img/cross-hover.svg);\n                    }\n                }\n            }\n\n            .description {\n                width: 419px;\n                margin-bottom: 5px;\n                font-family: Montserrat-Regular, sans-serif;\n                font-size: 15px;\n                line-height: 1.33;\n                text-align: left;\n            }\n\n            .subtitle {\n                margin-top: 12px;\n                font-family: WarnockPro-Regular, serif;\n                font-size: 15px;\n                text-align: left;\n                color: @secondary-30;\n                display: inline-block;\n                margin-right: 16px;\n            }\n\n            .dismiss-all {\n                font-family: WarnockPro-Regular, serif;\n                font-size: 15px;\n                color: @white;\n\n                &:hover,\n                &:focus  {\n                    color: @primary-90;\n                    cursor: pointer;\n                }\n            }\n\n            .action {\n                width: 70px;\n                height: 35px;\n                background-color: @primary-base;\n                cursor: pointer;\n                float: right;\n                text-align: center;\n\n                .text {\n                    font-family: Montserrat-Semibold, sans-serif;\n                    font-size: 14px;\n                    line-height: 35px;\n                    color: @white;\n                    text-decoration: none;\n\n                    &:hover {\n                        color: @white !important;\n                    }\n                }\n\n                &:hover,\n                &:focus {\n                    background-color: @primary-hover;\n                }\n            }\n\n            &.head {\n                padding-top: 26px;\n            }\n        }\n    }\n\n    .overlay {\n        background-color: transparent;\n        transition: background-color .2s cubic-bezier(.215,.61,.355,1);\n\n        &.active {\n            width: 1920px;\n            height: 100%;\n            position: absolute;\n            top: 0;\n            opacity: 0.75;\n            background-color: @black;\n            z-index: 30;\n        }\n    }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
